import { DASHBOARD_PATH, LANDLORD_DASHBOARD_PATH, LISTING_PATH, VENDOR_TASKS_PATH } from 'routes';

type PathToRedirect = {
  from: string;
  to: string;
  exact?: boolean;
  redirectId?: boolean;
};

export const pathsToRedirect: PathToRedirect[] = [
  {
    from: '/coworking-space',
    to: LISTING_PATH,
    redirectId: true
  },
  {
    from: '/app/offices',
    to: DASHBOARD_PATH,
    exact: true
  },
  {
    from: '/app/landlord',
    to: LANDLORD_DASHBOARD_PATH,
    exact: true
  },
  {
    from: '/app/tasks',
    to: VENDOR_TASKS_PATH,
    redirectId: true
  }
];
